import * as Step from "../../core/script/StepExecutor";

/**
 * Class used to alert UI
 */
export default class EQmScoreStepProgress {

    /**
     *
     * @param {string} direction
     * @param {number} timestamp of the measure in ms
     * @param {number} instantBytes
     * @param {number} instantTime
     * @param {number} totalBytes
     * @param {number} sessionTime
     * @param {GpsInfos} gpsInfos
     * @param {number} timeout
     * @param {object} gatewayInfos
     */
    constructor(direction, timestamp, instantBytes, instantTime, totalBytes, sessionTime, gpsInfos, timeout, gatewayInfos) {
        this.type = Step.STEP_MSCORE;
        this.timestamp = timestamp;
        this.direction = direction;
        this.instantBytes = instantBytes;
        this.instantTime = instantTime;
        this.totalBytes = totalBytes;
        this.sessionTime = sessionTime;
        this.gpsInfos = gpsInfos;
        this.timeout = timeout;
        this.routerInfos = gatewayInfos; // Gateway is called router in APIs
    }

    instantThroughput() {
        if (this.sessionTime == 0) {
            return 0;
        }
        return (this.totalBytes / 1000) / (this.sessionTime / 1000) * 8;
    }
}


// WEBPACK FOOTER //
// ./js/public-apis/onclick/EQmScoreStepProgress.js